import { connect } from 'react-redux'
import { changeTab } from '../../actions/TabAction'
import ContentPane from '../presentation/ContentPane'
import { getDocuments, setCurrentDocument, showErrorMessage} from '../../actions/DocumentAction'
import { VIEW_TAB } from '../../constants';

const mapStateToProps = (state, ownProps) => {
  console.log("--MapStateToProps for contentPane " + ownProps);
  return {
    state,
    activeTab: state.tab.activeTab,
    metadata: state.tab.metadata,
    documents: state.documents.rawlist,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeTab: (tabId, metadata, action) => {
      dispatch(changeTab(tabId, metadata, action))
    },
    searchDocuments: (docType, attributes) => {
          dispatch(getDocuments(docType, attributes));
        },
    showDocument: async (metadata, version) => {
          const r = await dispatch(setCurrentDocument(metadata, version));
          if (r.error) 
            dispatch(showErrorMessage(r.error));
          else 
            dispatch(changeTab(VIEW_TAB, metadata));
        },
  }
}

const ContentPaneView = connect(mapStateToProps, mapDispatchToProps)(ContentPane)

export default ContentPaneView;